import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { CalendarCheck, CalendarPlus } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";

type Status = { configured: boolean; connected: boolean; google_email: string };

export default function CalendarConnect() {
  const [s, setS] = useState<Status | null>(null);
  const [params, setParams] = useSearchParams();

  useEffect(() => {
    api.get("/calendar/status").then((r) => setS(r.data)).catch(() => {});
    const flag = params.get("calendar");
    if (flag) {
      flag === "connected" ? toast.success("Google Calendar connected") : toast.error("Google Calendar connection failed");
      params.delete("calendar");
      setParams(params, { replace: true });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (!s) return null;
  const connect = async () => {
    try {
      const { data } = await api.get("/calendar/connect");
      window.location.href = data.authorization_url;
    } catch (e) {
      toast.error(apiError(e));
    }
  };
  const disconnect = async () => {
    await api.post("/calendar/disconnect");
    setS({ ...s, connected: false, google_email: "" });
    toast.success("Google Calendar disconnected");
  };
  const cls = "flex items-center gap-1 rounded-sm border px-2.5 py-1.5 text-xs";
  if (s.connected)
    return (
      <button onClick={disconnect} title={`Synced to ${s.google_email} — click to disconnect`} data-testid="calendar-disconnect-button" className={`${cls} border-emerald-500/40 text-emerald-300 hover:border-red-500 hover:text-red-300`}>
        <CalendarCheck className="h-3.5 w-3.5" /> <span className="hidden sm:inline">Calendar synced</span>
      </button>
    );
  return (
    <button onClick={connect} disabled={!s.configured} title={s.configured ? "" : "Google Calendar credentials not configured yet"} data-testid="calendar-connect-button" className={`${cls} border-slate-700 text-slate-300 hover:border-brand-500 hover:text-brand-400 disabled:opacity-40`}>
      <CalendarPlus className="h-3.5 w-3.5" /> <span className="hidden sm:inline">Connect Google Calendar</span>
    </button>
  );
}
